import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Http, Response, RequestOptions, Headers, ResponseContentType } from '@angular/http';
import { GlobalDataService } from '../../../services/global-data.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';


@Injectable()
export class ReportService {

  constructor(
    private http: HttpClient,
    private httpOld: Http,
    private global: GlobalDataService) { }

  getReport(reportType:{}, isExport:boolean,filter:any) {
    let url = "";
    url = isExport==true ? 'is_export=1&' : 'is_export=0&'

    if(filter){
      for (var item of filter) {
        url += item.name + "=" + item.value + "&";
     }
    }
 
    url = url.substring(0,url.length-1);  

    let headers = new Headers(), authtoken = localStorage.getItem('token');
    headers.append("Authorization", 'Bearer' + authtoken);
    headers.append('X-Requested-With', 'XMLHttpRequest');
    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    return this.httpOld.post(this.global.httpUrl + "reports/"+reportType['name'], url, { headers: headers })
        .map((resp: Response) => resp.json())
        .catch((error: any) => { return Observable.throw(error); });
    
  }

 
}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/reports/report.service.ts